import { Children, DetailsHTMLAttributes, ReactNode, useId, useRef } from "react";
import styles from "./DropdownMenu.module.css";

type DropdownMenuProps = {
  children: ReactNode;
  enabled?: boolean;
  trigger(props: Pick<DetailsHTMLAttributes<HTMLDivElement>, "popoverTarget" | "style">): void;
} & DetailsHTMLAttributes<HTMLDivElement>;

export function DropdownMenu({ enabled = true, trigger, children }: DropdownMenuProps) {
  const popoverRef = useRef<HTMLDivElement | null>(null);
  const popoverTarget = useId();
  const anchorName = `--anchor-${popoverTarget}`;
  const triggerStyle: React.CSSProperties = { anchorName };

  if (enabled) {
    return (
      <>
        {trigger({
          popoverTarget,
          style: triggerStyle,
        })}

        <div
          ref={popoverRef}
          id={popoverTarget}
          popover="auto"
          style={{ positionAnchor: anchorName }}
          className={styles.dropdownMenuContent}
          onClick={() => popoverRef.current?.hidePopover()}
        >
          {Children.map(children, (child) => child)}
        </div>
      </>
    );
  }

  return <>{trigger({})}</>;
}
